import {get} from 'svelte/store';
import {analytics, dyData, modal, popupData} from 'general/store';
import {COOKIE_VALUE, VIEW} from 'general/constants';
import {setCookie} from '../setCookie';
import {expSetRightSide} from './expSetRightSide';

/**
 * Open is active popup
 * @param {string} popupType popup type
 */
export const openPopup = (popupType: string): void => {
    const modalState = get(modal);
    const data = get(popupData);

    if (
        (modalState.view === VIEW.MAIN && modalState.isVisible) ||
        Boolean(!data.value?.[popupType]?.template)
    ) {
        return;
    }

    if (modalState.popupSelectors.exitPopup === popupType) {
        setCookie(COOKIE_VALUE.IS_EXIT_SHOW, 'true', 1);
    }

    modal.hideCurrentPopup();
    dyData.set(data.value[popupType]);
    analytics.set(data.analytics[popupType]);
    expSetRightSide();
    modal.initialize(Boolean(data.value[popupType].isOpen));
};
